export const server = "https://totlesoft-imager-server.vercel.app/api";

//  http://localhost:5000/api
// https://totlesoft-imager-server.vercel.app/api